import { Route, Routes } from "react-router-dom";

import ErrorPage from "./contents/ErrorPage";
import HomePage from "./contents/HomePage";
import Ordinances from "./contents/Ordinances";
import ShowOrdinances from "./contents/ShowOrdinances";
import Resolutions from "./contents/Resolutions";
import ShowResolutions from "./contents/ShowResolutions";

const AppRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/ordinances" element={<Ordinances />} />
             <Route path="/ordinances/:ordno" element={<ShowOrdinances />} />
             <Route path="/resolutions" element={<Resolutions />} />
             <Route path="/resolutions/:resno" element={<ShowResolutions />} />

            <Route path="*" element={<ErrorPage />} />
        </Routes>
    );
};

export default AppRoutes;
